module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-33.321d7297.png";